import styled from 'styled-components';
import { Checkbox } from 'antd';

export const Container = styled.div`
  width: 100%;
  min-height: 400px;
  max-height: 100%;
  border-radius: 8px;
  padding: 1rem;
  background-color: #fff;
  display: flex;
  align-items: start;
  flex-direction: column;
  gap: 0.7rem;
  overflow: hidden;
  margin-top: 1rem;
`;

export const Title = styled.h3`
  color: #8a93ac;
  font-size: 1rem;
  margin: 0;
`;

export const ListContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: start;
  gap: 1rem;
  overflow: hidden;
`;

export const CustomsList = styled.div`
  width: 100%;
  max-height: 100%;
  min-height: 100%;
  border-radius: 8px;
  padding: 12px;
  background-color: #f7f8fc;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.5rem;
  overflow: hidden;

  h4 {
    color: #8a93ac;
    font-size: 0.9rem;
    margin: 0;
  }
`;

export const SelectedList = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.5rem;

  h4 {
    width: 100%;
    color: #8a93ac;
    font-size: 0.9rem;
    margin: 0;
    background-color: #eef1f6;
    border-radius: 12px;
    padding: 12px 0;
    text-align: center;
  }

  p {
    color: #979797;
    font-size: 14px;
    line-height: 19.6px;
    font-weight: 300;
    text-align: left;
    margin: 0;
  }
`;

export const SearchBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  padding: 9px 10px;
  background-color: #ffffff;
  box-shadow: 0 0 0 1px #e1dfec;
  border-radius: 10px;
  margin-top: 0.2rem;
`;

export const Icon = styled.div`
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  font-size: 0.9rem;

  &:focus {
    outline: none;
  }
`;

export const CustomItemsContainer = styled.div`
  width: 100%;
  max-height: 100%;
  overflow: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.5rem;
  padding: 1px 0.4rem 0.4rem 1px;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #e1dfec;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-corner {
    background: #f1f1f1;
  }
`;

export const CustomItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  box-shadow: 0 0 0 1px #e1dfec;
  border-radius: 10px;
  padding: 8px 10px;

  div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;

    h5 {
      font-size: 0.9rem;
      margin: 0;
      font-weight: 500;
    }

    p {
      color: #979797;
      font-size: 0.8rem;
      font-weight: 300;
      margin: 0;
    }
  }

  p {
    font-size: 0.9rem;
    margin: 0;
    font-weight: 500;
    margin: 0;
    color: #ff6464;
  }
`;

export const CustomCheckbox = styled(Checkbox)`
  .ant-checkbox-inner {
    border-color: #e8c9bf !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    border-color: #e8c9bf !important;
    background-color: #e8c9bf !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: #d18363 !important;
  }

  .ant-checkbox-title {
    font-weight: 600;
  }
`;

export const AddMenuBtn = styled.button`
  background-color: #f6e6e0;
  color: var(--primary-green);
  font-size: 0.8rem;
  margin: 0;
  font-weight: 500;
  padding: 8px 30px;
  border-radius: 8px;
  border: none;
  align-self: start;
  margin-top: auto;
`;

export const SelectedItemsList = styled.div`
  width: 100%;
  max-height: 100%;
  overflow: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.5rem;
  padding: 1px 0.4rem 0.4rem 1px;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #e1dfec;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-corner {
    background: #f1f1f1;
  }
`;

export const SelectedItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e1dfec;
  border-radius: 10px;
  padding: 10px 12px;

  h5 {
    font-size: 0.9rem;
    margin: 0;
    font-weight: 500;
  }

  div {
    display: flex;
    align-items: center;
    gap: 0.6rem;
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
`;

export const Button = styled.button`
  height: 50px;
  width: 10rem;
  background: var(--primary-green);
  border-radius: 10px;
  padding: 10px 50px;
  border: none;
  font-style: normal;
  font-weight: 500;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  color: var(--white);
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0em;
  margin-top: 0.5rem;
`;
